import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { appointments } from './appointments.reducer';
import { dashboard } from './dashboard.reducer';
import { leadAcceptance } from './lead-acceptance.reducer';
import { login } from './login.reducer';
import { notifications } from './notifications.reducer';
import { referrals } from './referrals.reducer';
import { userprofile } from './userprofile.reducer';
import { header } from './header.reducer';
import { bottomnav } from './bottomnav.reducer';
import { modals } from './modals.reducer';
import { member } from './member.reducer';
import { tasks } from './tasks.reducer';
import { contacts } from './contacts.reducer';

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  appointments,
  dashboard,
  leadAcceptance,
  login,
  notifications,
  referrals,
  userprofile,
  header,
  bottomnav,
  modals,
  member,
  tasks,
  contacts
});

export default createRootReducer;
